module.exports = __webpack_public_path__ + "media/escudos/logo_muni_lobitos-a027f11f.png";